export default __webpack_public_path__ + "static/media/darkcorruption.226bc51c.png";